import { FileUploadHeaderType, IFileUploadHeader } from './Interfaces';

const LatLngDict = {
    latitudeTypes: new Set(['latitude', 'lat', 'y', 'northing']),
    longitudeTypes: new Set(['longitude', 'lng', 'long', 'x', 'easting']),
    getDistinctField: (
        headersArray: Array<IFileUploadHeader>,
        headerType: FileUploadHeaderType
    ): IFileUploadHeader => {
        const comparisonSet =
            headerType === FileUploadHeaderType.LATITUDE
                ? LatLngDict.latitudeTypes
                : LatLngDict.longitudeTypes;

        const intersection = headersArray.filter((header) =>
            comparisonSet.has(header.value.toLowerCase())
        );

        return intersection.length === 1 ? intersection[0] : null;
    },
};

export default LatLngDict;
